import requestModule from '@/assets/libs/requestModule'
import Util from '@/assets/libs/util'
import CartController from '@/assets/controllers/CartController'

let differentiatedPrices = null

const getDiffPrices = function () {
    return differentiatedPrices
}

const fetchDiffPrices = async function (clientCode, consumerCode) {
    let requestParams = {
        storeCode: Util.getGeneralInfo()['storeCode'],
        subsidiaryCode: Util.getGeneralInfo()['subsidiaryCode'],
        clientCode: clientCode,
        consumerCode: consumerCode
    }

    await requestModule.postRequest('menu/getDifferentiatedPrice', requestParams)
        .then(res => {
            let isValidResponse = res && !res.error && !!res.data
            differentiatedPrices = isValidResponse ? formatDiffPricesAsObject(res.data) : {}
        })
        .catch((e) => {
            differentiatedPrices = {}
        })
}

const formatDiffPricesAsObject = function (diffPrices) {
    if (!diffPrices || diffPrices === null) {
        return {}
    }
    if (!Array.isArray(diffPrices)) {
        return diffPrices
    }
    try {
        let diffPricesAsObject = {}
        diffPrices.forEach(element => {
            let key = Object.keys(element)[0]
            let value = Object.values(element)[0]
            diffPricesAsObject[key] = value
        })
        return diffPricesAsObject
    } catch (error) {
        console.log(error.message)
        return {}
    }
}

const clearDiffPrices = function () {
    differentiatedPrices = []
    CartController.setAppliedDiffPrices(false)
}

const getDiffPrice = function (productCode, isCombo, productRaw) {
    let product = (differentiatedPrices && differentiatedPrices[productCode] && differentiatedPrices[productCode])
    let rawDiscount = productRaw.discount ? productRaw.discount : 0
    let rawAddition = productRaw.addition ? productRaw.addition : 0
    let diffPrice = 0
    if (productRaw.hasAppliedDiffPrices) {
        return productRaw.price
    }
    if (product && isCombo) {
        let appyCombo = product.applyInCombo === 'S'
        if (appyCombo) {
            /* O desconto deve ser acumulado no preço do combo e preço diferenciado */
            let diffDiscount = product.discount ? product.discount : 0
            let diffAddition = product.addition ? product.addition : 0
            let diffFullPrice = product.fullPrice ? product.fullPrice : 0
            diffDiscount = diffDiscount + rawDiscount
            diffAddition = diffAddition + rawAddition
            diffPrice = diffFullPrice - diffDiscount + diffAddition
            diffPrice = diffPrice > 0 ? diffPrice : 0.01
            productRaw.price = diffPrice
            return diffPrice
            // return product.price
        }
        return null
    }
    if (product) {
        let diffDiscount = product.discount ? product.discount : 0
        let diffAddition = product.addition ? product.addition : 0
        let diffFullPrice = product.fullPrice ? product.fullPrice : 0
        diffDiscount = diffDiscount + rawDiscount
        diffAddition = diffAddition + rawAddition
        diffPrice = diffFullPrice - diffDiscount + diffAddition
        return diffPrice > 0 ? diffPrice : 0.01
    }
    return null
}

export default {
    getDiffPrices,
    fetchDiffPrices,
    clearDiffPrices,
    getDiffPrice
}



// WEBPACK FOOTER //
// ./src/assets/controllers/DifferentiatedPricesController.js